//типы устройств
export const RS_DEVICE_TYPES = [
    { value: 1, label: 'ПЛК' },
    { value: 2, label: 'Пч Инстарт' },
    { value: 3, label: 'Пч ESQ' },
    { value: 4, label: 'Пч Альтивар' }
]

export const DEVICE_SUBTYPE_NAMES = {
    1: ['Шнайдер m241', 'Овен ПР100', 'Овен ПР200'],
    2: ['MCI/FCI', 'LCI'],
    3: ['ESQ 760/770'],
    4: ['ATV_610']
  };

export const EQUIPMENT_CONFIG_MAP = { 
    1: { // ПЛК
        0: [11, 12], //Шнайдер, cfg_11; Шнайдер+sms, cfg_12
        1: [13, 14], //Овен Пр100, cfg_13; Пр100+sms, cfg_14
        2: [15, 16],  //Овен Пр200, cfg_15; Пр200+sms, cfg_16
    },
    2: { // Пч_Инстарт
        0: [3, 4], //MCI_FCI, cfg_3;  MCI_FCI+sms, cfg_4
        1: [5, 6] //LCI, cfg_5; LCI+sms, cfg_6
    },
    3: { // Пч_ESQ
        0: [7, 8] //ESQ 760_770, cfg_7; ESQ 760_770+sms, cfg_8
    },
    4: { // Пч_ATV
        0: [9, 10] //ATV_610, cfg_9; ATV_610+sms, cfg_10
    }
};

//обратные мапы для обратных преобразований
export const REVERSE_CONFIG_MAP = {
    11: { type: 1, subtype: 0 }, //cfg_11: (type: ПЛК, subtype: Шнайдер)
    12: { type: 1, subtype: 0 }, //cfg_12: (type: ПЛК, subtype: Шнайдер+смс)
    13: { type: 1, subtype: 1 }, //cfg_13: (type: ПЛК, subtype: Овен Пр100)
    14: { type: 1, subtype: 1 }, //cfg_14: (type: ПЛК, subtype: Овен Пр100+смс)
    15: { type: 1, subtype: 2 }, //cfg_15: (type: ПЛК, subtype: Овен Пр200)
    16: { type: 1, subtype: 2 }, //cfg_16: (type: ПЛК, subtype: Овен Пр200+смс)
    3: { type: 2, subtype: 0 }, //cfg_3: (type: Пч_Инстарт, subtype: MCI)
    4: { type: 2, subtype: 0 }, //cfg_4: (type: Пч_Инстарт, subtype: MCI+смс)
    5: { type: 2, subtype: 1 }, //cfg_3: (type: Пч_Инстарт, subtype: LCI)
    6: { type: 2, subtype: 1 }, //cfg_6: (type: Пч_Инстарт, subtype: LCI+смс)
    7: { type: 3, subtype: 0 }, //cfg_7: (type: Пч_ESQ, subtype: ESQ_760)
    8: { type: 3, subtype: 0 }, //cfg_7: (type: Пч_ESQ, subtype: ESQ_760+смс)
    9: { type: 4, subtype: 0 },   //cfg_9: (type: Пч_ATV, subtype: ATV_610)
    10: { type: 4, subtype: 0 }   //cfg_9: (type: Пч_ATV, subtype: ATV_610+смс)
};